import * as React from "react";
import * as ReactDOM from "react-dom";

import { EnquiryProvider } from "./context/EnquiryState";
import { EnquiryContext } from "./context/EnquiryState";
import { ImageComponent } from "./ImageComponent";
import { FormComponent } from "./FormComponent";
import { ThankYouComponent } from "./ThankYouComponent";

import type * as Types from "./context/EnquiryTypes";

type Props = {
	data: Types.modelObject
};

const generalEnquiry = {
	label: "General enquiry",
	id: 1,
	steps: 1,
};
 
const liveTourBooking = {
	label: "Live Tour Booking",
	id: 4,
	steps: 3,
};

const embeddedTourBooking = {
	label: "Live Tour Booking",
	id: 5,
	steps: 1,
};

const EnquiryComponent = (props: Props) => {

	const {
		state,
		dispatch,
		Exit
	} = React.useContext(EnquiryContext)

	React.useEffect(() => {
		//console.log('ENQ PROPS', props.data)

		dispatch({ type: 'SET_MODEL', payload: props.data })

		// Check if we have multiple centres or not
		if (props.data.enquiryCentreDetailsList.length == 1) {
			// if live tour book request straight from a CTA, type is 4 and check a tour type is available
			if (props.data.enquiryType == 4 && (props.data.enquiryCentreDetailsList[0].isLiveTourBookingAvailable || props.data.enquiryCentreDetailsList[0].hasEmbeddedRequestATour)) {
				let payload = props.data.enquiryCentreDetailsList[0].hasEmbeddedRequestATour ? embeddedTourBooking : liveTourBooking
				dispatch({
					type: 'SELECT_OPTION', payload: payload
				})
			} else if (!props.data.enquiryCentreDetailsList[0].isLiveTourBookingAvailable && !props.data.enquiryCentreDetailsList[0].hasEmbeddedRequestATour) {
				// No tours available so go straight to general enquiry
				dispatch({ type: 'SELECT_OPTION', payload: generalEnquiry })
			}
		} else if (props.data.enquiryCentreDetailsList.length > 1) {
			dispatch({ type: 'SELECT_OPTION', payload: generalEnquiry })
		}

		// If Logged in user, populate user info
		if (props.data.isLoggedIn) {

			let name = (!!props.data.parentLastName && props.data.parentLastName != "") ? props.data.parentFirstName + " " + props.data.parentLastName : props.data.parentFirstName

			let clonedForm = state.form
			clonedForm.parentFullName = name
			clonedForm.email = props.data.parentEmail
			clonedForm.contactNumber = props.data.parentContactNumber

			dispatch({ type: 'UPDATE_FORM', payload: clonedForm })
		}

		// Event listener for auto close modal
		window.addEventListener('autoclosemodal', () => Exit(props.data.closeUrl))
	}, [])

	return (
		<React.Fragment>
			{!state.submitSuccess &&
				<div className="bg-skin-site-header sm:py-8">
					<div className="container mx-auto">
						<div className="sm:rounded-40px bg-white overflow-hidden md:mx-8 xl:mx-24 2xl:mx-36" style={{ boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)' }}>

							<div className="flex flex-row">
								{/*Image Component*/}
								<ImageComponent promo={props.data.freeChildCarePromo} />

								{/*Form Component*/}
								<FormComponent />
							</div>

						</div>
					</div>
				</div>
			}

			{state.submitSuccess &&
				<ThankYouComponent />
			}

		</React.Fragment>
	);

}

(window as any).RenderEnquiryComponent = function (props) {
	ReactDOM.render(
		<EnquiryProvider>
			<EnquiryComponent {...props} />
		</EnquiryProvider>
		, document.getElementById("enquiryComponent"));
}